import { createSelector } from 'reselect'

import _ from 'lodash'

export const getElement = (state, props) => {
  return state['view-card'].elements.elementsById[props.id]
}

export const getItemsById = (state, props) => {
  return state['view-card'].checklistItems[props.cardContext.id]
}

export const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getStatusId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].statusId
}

const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

export default () => createSelector(
  [
    getElement,
    getItemsById,
    getIsCardArchived,
    getBoardId,
    getStatusId,
    getIsTemplate,
  ],
  (
    element,
    itemsById,
    isCardArchived,
    boardId,
    statusId,
    isTemplate,
  ) => {
    let itemsCount = 0
    let completedItemsCount = 0
    element.items.forEach(itemId => {
      itemsCount++
      if (itemsById[itemId].completed) completedItemsCount++
    })

    return {
      isCardArchived,
      boardId,
      statusId,
      items: element.items,
      itemsCount,
      completedItemsCount,
      isBusy: element.isBusy,
      isNewlyAdded: element.isNewlyAdded,
      isTemplate,
    }
  }
)
